import icon1 from '../images/mentImg/Vasudha-Asher.jpg'
import icon2 from  "../images/mentImg/Anahita-Medhora.jpg"
import icon3 from "../images/mentImg/Anshul-Jain.jpg"
import icon4 from  "../images/mentImg/Ipsita-Chowdhury.jpg"
import icon5 from  "../images/mentImg/Asha-Krishnan.jpg"
import icon6 from  "../images/mentImg/Jolly_Abraham.jpg"
import icon7 from  "../images/mentImg/Harjot_Dhaliwal.jpg"
import icon8 from  "../images/mentImg/Nidhi-Prabhakar-Ghuman.jpg"
import icon9 from  "../images/mentImg/Ruchi_Khajanchi_new.jpg"
import icon10 from  "../images/mentImg/Fatima-Sami.jpg"
import icon11 from  "../images/mentImg/Mahua_Roy.jpg"
import icon12 from  "../images/mentImg/Sakshi_Chopra.jpg"

const mentConstant = [
    {
    imgUrl: icon2,
    name: "Anahita Medhora",
    oldpost: "Managing Director\n",
    oldcompany : "Everstone Group",
    newpost: "Vice President \n",
    newcompany: "Everstone Capital",
    linkedIn: "https://www.linkedin.com/in/anahitamedhora/"
  },
  {
    imgUrl: icon3,
    name: "Anshul Jain",
    oldpost: "Managing Director\n",
    oldcompany : "Lighthouse Funds",
    newpost: "Managing Director\n",
    newcompany: "Lighthouse Advisors",
    linkedIn: "https://www.linkedin.com/in/anshul-jain-3584321/"
  },
  { imgUrl: icon5,
    name: "Asha Krishnan",
    oldpost: "Vice President\n",
    oldcompany : "General Atlantic",
    newpost: "Operating Director\n",
    newcompany: "General Atlantic",
    linkedIn: "https://www.linkedin.com/in/asha-krishnan-7332b79/"
  },
  { imgUrl: icon10,
    name: "Fatima Sami",
    oldpost: "Director\n",
    oldcompany : "Unilever",
    newpost: "CFO\n",
    newcompany: "Hector Beverages",
    linkedIn: "https://www.linkedin.com/in/fatima-sami-78ab0819/"
  },
  { imgUrl: icon7,
    name: "Harjot Dhaliwal",
    oldpost: "Partner, Head of India\n",
    oldcompany : "Apax Partners",
    newpost: "Principal\n",
    newcompany: "Apax Partners",
    linkedIn: "https://www.linkedin.com/in/harjot-dhaliwal-691a6517/"
  },
  { imgUrl: icon4,
    name: "Ipsita Chowdhury",
    oldpost: "Associate General Counsel\n",
    oldcompany : "Blinkit",
    newpost: "Counsel\n",
    newcompany: "Trilegal",
    linkedIn: "https://www.linkedin.com/in/ipsita-chowdhury-8a408919/"
  },
  { imgUrl: icon6,
    name: "Jolly Abraham",
    oldpost: "Managing Director and General Counsel\n",
    oldcompany : "True North",
    newpost: "Director\n",
    newcompany: "True North",
    linkedIn: "https://www.linkedin.com/in/jolly-abraham-5b5a0613/"
  },
  { imgUrl: icon11,
    name: "Mahua Roy",
    oldpost: "AVP Business Finance\n",
    oldcompany : "Ecom Express",
    newpost: "Deputy General Manager\nCommercial Finance\n",
    newcompany: "Ecom Express",
    linkedIn: "https://www.linkedin.com/in/mahua-roy-7a991348/"
  },
  { imgUrl: icon8,
    name: "Nidhi Prabhakar Ghuman",
    oldpost: "Managing Partner\n ",
    oldcompany : "Vincere Partners",
    newpost: "Principal\n",
    newcompany: "Multiples Alternate Asset Management",
    linkedIn: "https://www.linkedin.com/in/nidhiprabhakarghuman/?original_referer=https%3A%2F%2Fwww%2Egoogle%2Ecom%2F&originalSubdomain=in"
  },
  { imgUrl: icon9,
    name: "Ruchi Khajanchi",
    oldpost: "CFO \n",
    oldcompany : "A91 Partners",
    newpost: "-",
    newcompany : "-",
    linkedIn: "https://www.linkedin.com/in/ruchi-khajanchi-7845028/"
  },
  { imgUrl: icon12,
    name: "Sakshi Chopra",
    oldpost: "Managing Director\n",
    oldcompany : "Peak XV Partners",
    newpost: "Principal\n",
    newcompany: "Sequoia Capital",
    linkedIn: "https://www.linkedin.com/in/sakshi-chopra-4aa1881/"
  },
  { imgUrl: icon1,
    name: "Vasudha Asher",
    oldpost: "Partner\n",
    oldcompany : "AZB & Partners",
    newpost: "Senior Associate\n",
    newcompany: "AZB & Partners",
    linkedIn: "https://www.linkedin.com/in/vasudha-asher-86a40722/"
  }
	 
      
]

export default mentConstant


// WEBPACK FOOTER //
// ./src/constant/mentConstant.js